import { ResponseData } from '~/core/api/ResponseTypes';
import { State } from '../types/state';

const updateResults = (state: State, payload: ResponseData): State => {
    const newResults = state.results.sets.map((set) => {
        const setUpdate = payload.results.find((updateSet) => updateSet.querySetIdentifier === set.querySetIdentifier);
        if (setUpdate === undefined) {
            return set;
        }
        return {
            ...set,
            hits: [...set.hits, ...setUpdate.hits],
        };
    });

    return {
        ...state,
        results: {
            ...state.results,
            sets: newResults,
        },
    };
};

export default updateResults;
